






































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import SMSConfigPO from "@/store/entities/messageinfo/smsconfigpo";
import TreeSelect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Util from "@/lib/util";

@Component({
    components: { TreeSelect },
})
export default class CopySMSConfig extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    smsconfigpo: SMSConfigPO = new SMSConfigPO();
    loading: boolean = false;
    create() { }
    async created() {
        await this.areaTree();
        await this.getOrganizations();
        this.getItemDetail();
    }
    //获取组织
    async getOrganizations() {
        await this.$store
            .dispatch("organization/getselectTree")
            .then((val) => {
                this.$data.organizations = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    //明细
    getItemDetail() {
        if (localStorage.getItem("itemdetail") === null) {
            this.$store.dispatch({
                type: "itemdetail/getdetailtolocalstorge",
            });
        }
        let detaillist = JSON.parse(localStorage.getItem("itemdetail"));
        if (detaillist.length > 0) {
            let info = detaillist.filter((p) => {
                return p.itemId == 23;
            });
            info.forEach((ele) => {
                this.$data.smsPlatform.push({
                    label: ele.name,
                    value: ele.id,
                });
            });
            info = detaillist.filter((item) => {
                return item.itemId == 18;
            })
            info.forEach((item) => {
                this.$data.waringType.push({
                    label: item.name,
                    value: item.id,
                })
            });
        }
    }
    //保存
    save() {
        (this.$refs.itemForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.loading = true;
                await this.$store
                    .dispatch({
                        type: "smsconfig/update",
                        data: this.smsconfigpo,
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
                this.loading = false;
                (this.$refs.itemForm as any).resetFields();
                this.$emit("save-success");
                this.$emit("input", false);
            }
        });
    }
    async areaTree() {
        await this.$store
            .dispatch("area/getAreaSelectTree")
            .then((val) => {
                this.$data.arealist = val;
            })
            .catch((err) => {
                console.log(err);
            });
    }
    cancel() {
        (this.$refs.itemForm as any).resetFields();
        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            this.smsconfigpo = Util.extend(true, {}, this.$store.state.smsconfig.smsConfigItems);
            this.smsconfigpo.name = "";
            this.smsconfigpo.waringType = 0;
        }
    }
    itemRule = {
        areaId: [
            {
                required: true,
                type: "number",
                message: this.L("FieldIsRequired"),
                trigger: "blur",
            },
        ],
        organizationId: [
            {
                required: true,
                type: "number",
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        smsPlatform: [
            {
                required: true,
                type: "number",
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        name: [
            {
                required: true,
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        smsUrl: [
            {
                required: true,
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        smsAppId: [
            {
                required: true,
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        smsAppSecret: [
            {
                required: true,
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        smsTemplateId: [
            {
                required: true,
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
        smsSender: [
            {
                required: true,
                message: this.L("CanNotBeEmpty"),
                trigger: "blur",
            },
        ],
    };

    data() {
        return {
            arealist: [],
            organizations: [], //组织
            smsPlatform: [], //短信平台
            waringType: [],//告警类型
            normalizer(node) {
                if (node.children && !node.children.length) {
                    delete node.children;
                }
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children,
                    isDisabled: node.type == 1 ? true : false,
                };
            },
        };
    }
}
